import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { Loader2, Lock } from "lucide-react";
import { Toaster } from "../components/ui/sonner";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
 const { user, login } = useAuth();
 const nav = useNavigate();
 const [email, setEmail] = useState("");
 const [password, setPassword] = useState("");
 const [loading, setLoading] = useState(false);

 if (user === undefined) return null;
 if (user) return <Navigate to="/admin" replace />;

 async function submit(e) {
 e.preventDefault();
 setLoading(true);
 try {
 await login(email, password);
 toast.success("Welcome back.");
 nav("/admin", { replace: true });
 } catch (err) {
 toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
 } finally {
 setLoading(false);
 }
 }

 return (
 <div className="min-h-screen flex items-center justify-center bg-cream container-pad py-16">
 <Toaster richColors position="top-right" />
 <div className="w-full max-w-md">
 <div className="flex justify-center mb-8"><Logo /></div>
 <div className="card-soft p-8 sm:p-10">
 <div className="flex items-center gap-3 mb-6">
 <div className="w-10 h-10 rounded-2xl bg-sage-50 text-sage-700 flex items-center justify-center">
 <Lock className="w-5 h-5" strokeWidth={1.75} />
 </div>
 <div>
 <h1 className="font-heading text-2xl font-semibold text-ink">Admin sign in</h1>
 <p className="text-sm text-muted_text">Authorised personnel only.</p>
 </div>
 </div>
 <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
 <div>
 <Label htmlFor="email">Email</Label>
 <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 mt-2" data-testid="admin-email" />
 </div>
 <div>
 <Label htmlFor="password">Password</Label>
 <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 mt-2" data-testid="admin-password" />
 </div>
 <Button type="submit" disabled={loading} className="btn-primary !rounded-full !h-12 w-full !text-base disabled:opacity-60" data-testid="admin-login-submit">
 {loading ? (<><Loader2 className="w-4 h-4 animate-spin" /> Signing in...</>) : "Sign in"}
 </Button>
 </form>
 </div>
 </div>
 </div>
 );
}
